import React from 'react';
import { useIntl } from 'react-intl';

import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { CreateTemplateWizardContainer } from './create-template-wizard-container';

export type CreateTemplateSidebarMode = 'report' | 'dashboard';

interface CreateTemplateSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  mode?: CreateTemplateSidebarMode;
  preSelectedReportId?: string;
}

export const CreateTemplateSidebar = ({ isOpen, onClose, mode = 'report', preSelectedReportId }: CreateTemplateSidebarProps) => {
  const intl = useIntl();
  const isDashboard = mode === 'dashboard';

  return (
    <Sidebar
      header={
        <Typography variant="h2" fontWeight="700">
          {isDashboard
            ? intl.formatMessage({ id: 'reporting.create_a_dashboard_template', defaultMessage: 'Create a dashboard template' })
            : intl.formatMessage({ id: 'reporting.create_a_report_template', defaultMessage: 'Create a report template' })}
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
    >
      <CreateTemplateWizardContainer onClose={onClose} mode={mode} preSelectedReportId={preSelectedReportId} />
    </Sidebar>
  );
};
